export default __webpack_public_path__ + "static/media/swiming-icon.0205af16.svg";